import { AxiosResponse } from "axios";

import API from "../api";

import { Subscription, ContainerStatus, ContainerPosition } from "../models/marine.traffic";
import { Shipment } from "../models/shipments";
import { ShipmentType } from "Util/enums";
import { shipmentType } from "../translate/locales/en_US";

const ROUTE_NAME = "marine/traffic/container";

const MarineTrafficService = {
  async subscribe(body: any): Promise<AxiosResponse<Subscription>> {
    return await API.post(`/${ROUTE_NAME}/subscription`, body);
  },
  async status(trackingId: string, type?: string, shipmentId?:number): Promise<AxiosResponse<ContainerStatus>> {
    return await API.get(`/${ROUTE_NAME}/status/${trackingId}`, { params: { type, shipmentId } });
  },

  async statusFetchingDetails(
    shipmentId: string,
    type?: string
  ): Promise<AxiosResponse<ContainerStatus>> {
    let paramsUrl = "";
    if (type === ShipmentType.SEA) {
      paramsUrl = `billOfLanding=${shipmentId}`;
    } else if (type === ShipmentType.AIR) {
      paramsUrl = `airWaybill=${shipmentId}`;
    }
    return await API.get(`/${ROUTE_NAME}/status/${shipmentId}?${paramsUrl}`);
  },

  async viewShipmentTracking(
    trackingId: string,
    shipmentId: string,
    type?: string
  ): Promise<AxiosResponse<ContainerStatus>> {
    return await API.get(`/${ROUTE_NAME}/status/${trackingId}`, { params: { shipmentId, type } });
  },

  async containerPosition(vesselShipmentId: string): Promise<AxiosResponse<ContainerPosition[]>> {
    return await API.get(`marine/traffic/vessel/position/${vesselShipmentId}`);
  },
  async sendSms(body: any): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/send/sms`, body);
  },
  async sendEmail(body: any): Promise<AxiosResponse<boolean>> {
    return await API.post(`/${ROUTE_NAME}/send/email`, body);
  },
};

export default MarineTrafficService;
